export const about = [
  {
    text: 'whoWeAre',
    url: `${process.env.NEXT_PUBLIC_LEGACY_HOST}/${process.env.NEXT_PUBLIC_COUNTRY}/quienes-somos`
  },
  {
    text: 'publish',
    url: `${process.env.NEXT_PUBLIC_LEGACY_HOST}/${process.env.NEXT_PUBLIC_COUNTRY}/publica`
  },
  {
    text: 'plans',
    url: `${process.env.NEXT_PUBLIC_LEGACY_HOST}/${process.env.NEXT_PUBLIC_COUNTRY}/planes`
  }
];

export const help = [
  {
    text: 'termsAndConditions',
    url: `${process.env.NEXT_PUBLIC_LEGACY_HOST}/${process.env.NEXT_PUBLIC_COUNTRY}/terminos-y-condiciones`
  },
  {
    text: 'configureMyAccount',
    url: `${process.env.NEXT_PUBLIC_LEGACY_HOST}/${process.env.NEXT_PUBLIC_COUNTRY}/configuracion-de-datos`
  }
];

export const myAccount = [
  {
    text: 'myAccount',
    url: `${process.env.NEXT_PUBLIC_LEGACY_HOST}/${process.env.NEXT_PUBLIC_COUNTRY}/configuracion-de-datos`
  },
  {
    text: 'myPosts',
    url: `${process.env.NEXT_PUBLIC_LEGACY_HOST}/${process.env.NEXT_PUBLIC_COUNTRY}/usuarios/publicaciones-activas`
  }
];

export const socialMedia = [
  {
    text: 'Facebook',
    url: 'facebook'
  },
  {
    text: 'Instagram',
    url: 'instagram'
  },
  {
    text: 'LinkedIn',
    url: 'linkedin'
  }
];
